enum ActionTypes {
  MAIN_INTERVIEWS_SET_PAGE = 'MENTEE_MAIN_INTERVIEWS_SET_PAGE',
  MAIN_INTERVIEWS_SET_ORDER = 'MENTEE_MAIN_INTERVIEWS_SET_ORDER',
}

export default ActionTypes;
